import { render } from "./Button.vue?vue&type=template&id=506a2670&scoped=true"
import script from "./Button.vue?vue&type=script&lang=js"
export * from "./Button.vue?vue&type=script&lang=js"

import "./Button.vue?vue&type=style&index=0&id=506a2670&lang=postcss&scoped=true"
script.render = render
script.__scopeId = "data-v-506a2670"

export default script